import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/auth/verifyMagicLink';
import { BASE_API_URL } from '../../../config';
import { applyCellRouting } from '../../../cellRouting';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const { token } = action.payload;
    // Verify against the BAKED login/router endpoint: at this point we don't yet
    // know the user's cell. The response carries `cell` + `api_base_url`, which
    // we persist so all subsequent calls route to the user's own cell.
    const response = yield call(axios.get,
      `${BASE_API_URL}/user/verify-magic-link?token=${token}`
    );

    // Tolerate both the raw shape and the ``data`` envelope
    // (responseJSON) so the stored user — including the timezone
    // preference utils/datetime reads — is always populated.
    const payload = response.data?.data ?? response.data ?? {};
    const { token: jwtToken, user, cell, api_base_url: apiBaseUrl } = payload;

    // Store JWT token in localStorage
    localStorage.setItem('authToken', jwtToken);
    localStorage.setItem('user', JSON.stringify(user));

    // Persist the user's cell routing (cell -> api_base_url) before anything
    // else fires API calls.
    yield call(applyCellRouting, { token: jwtToken, cell, apiBaseUrl });

    // Clear pending email
    localStorage.removeItem('pendingEmail');

    yield put(fetchSuccess(response.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
